<template>
	<div>
		<legend>{{ legend }}
			<a @click="$emit('close')" href="#" class="btn pull-right closeWindow">
				<i class="fas fa-times fa-2x"></i>
		  	</a>
		</legend>
		<form>
		  	<v-select  type="text" name="activity_id" title="Prestation existante *" v-model="current.activity" :items="activities" @input="setTitle(current.activity)" v-validate="'required'" data-vv-name="Prestation existante"></v-select>
	      	<div class="row">
	        	<v-date :errors="errors" name="start" title="Date de début *" format="YYYY-MM-DD HH:mm:ss" v-model="current.eventStart" v-validate="'required'" data-vv-name="Date de début"></v-date>
	        	<v-date :errors="errors" name="end" title="Date de fin *" format="YYYY-MM-DD HH:mm:ss" v-model="current.eventEnd" v-validate="'required'" data-vv-name="Date de fin" ></v-date>
	      	</div>
			<v-input :errors="errors" type="text" name="meeting_point" title="Lieu de RDV" v-model="current.meeting_point"></v-input>
			<v-input :errors="errors" type="number" name="total_places" title="Nombre de places ouvertes *" v-model="bookingMultiple.total_places" v-validate="'required|integer|min_value:0'" data-vv-name="Nombre de places ouvertes"></v-input>
			<v-ckeditor name="remarques" title="Remarques " v-model="bookingMultiple.comment"></v-ckeditor>
			<div class="form-group">
			    <div class="form__label">
			      	<label>Choisissez une couleur *: </label>
			    </div>
			    <div class="form__input">
			      	<swatches v-model="color" inline @input="validate"></swatches>
			    </div>
			</div>
			<div class="alert alert-danger"  v-show="customErrorMessage.error === true&&ferrors.all().length>0||customErrors.length>0">
				<h3>{{customErrorMessage.message}}</h3><hr>
				<ul>
				    <li v-for="(error,eidx) in ferrors.all()" v-bind:key="eidx">{{ error }}</li>
				    <li v-for="(cerror,cidx) in customErrors" v-bind:key="cidx">{{ cerror }}</li>
				</ul>
			</div>
			<button v-show="isEdited" @click.prevent="deleteBookingMultiple" class="btn btn-block btn-right btn-danger">Supprimer</button>
		    <button @click.prevent="addBookingMultiple()" class="btn btn-block green" >{{isEdited? 'Sauvegarder': 'Créer'}}</button>
		    <button v-show="isEdited" class="btn btn-block btn-primary" @click.prevent="$emit('edit-booking-multiple-group')">Remplir l'activité</button>
		</form>
	</div>
</template>
<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
export default {
	name: 'calBookingMultiple',
	props: ['legend','current','bookingMultiple','activities'],
	components: {
		Swatches,
		VueCtkDateTimePicker,
		'v-select-lib': vSelect
	},
	data() {
		return {
			errors: {},
			customErrorMessage:{
				error:false,
				message: '',
			},
			customErrors: [],
			color: this.current.color,
			isEdited:this.bookingMultiple.hasOwnProperty('id')
		}
	},
	methods: {
		setTitle(id) {
			if (this.bookingMultiple.activity != "") {
				this.activities.forEach(element => {
					if (element.id === id) {
						this.current.title = element.name
					}
				})
			}
			return this.bookingMultiple.title
		},
		async validate(){
			let err = 0
			await this.$validator.validateAll().then((result) =>{
				if (!result){
					err=this.ferrors.all().length
				}
			});
			if(err>0){
				let msg = (err>1) ? 'Erreurs lors de la validation :' : 'Erreur lors de la validation :'
				this.customErrorMessage = {error : true, message : msg}
			}
			return err<=0
		},
		async addBookingMultiple() {
			if(await this.validate()){
				const newBookingMultipleData={
					bookingMultiple:{
						total_places: this.bookingMultiple.total_places,
						comment: this.bookingMultiple.comment,
						event_id: this.bookingMultiple.eventId
					},
					event:{
						activity_id: this.current.activity,
						title: this.current.title,
						meeting_point: this.current.meeting_point,
						start: this.current.eventStart,
						end: this.current.eventEnd,
						color : this.color
					}
				}
				let met = 'post'
				let route = 'calendar/event/bookingmultiple'
				if(this.bookingMultiple.hasOwnProperty('id')){
					met ='put'
					route+='/'+this.bookingMultiple.eventId
				}
				axios[met](route, newBookingMultipleData ).then(response => {
					this.$emit('close')
					this.$emit('refetch-events')
					this.$emit('snotify')
				}).catch(function(error){
					vm.$snotify.error(error.response.statusText,'Erreur '+error.response.status,{timeout:5000})
				})
			}
		},
		deleteBookingMultiple(event){
			let cleanGroups=this.bookingMultiple.groups.filter(function(group){return group!=null})
			let hasGroupError = "Cette activité contient des groupes, veuillez les retirer avant de pouvoir supprimer cette activité."
			if(cleanGroups.length>0){
				this.customErrorMessage = {error : true,message:"Erreur lors de la suppression :"}
				this.customErrors= [hasGroupError]
			}else{
				this.customErrorMessage = {error : false}
				let confirmConfig={
					title:'Êtes-vous sûr de vouloir supprimer ?',
					btnOkLabel:'<i class="icon-ok-sign icon-white"></i> Oui',
					btnCancelLabel:'<i class="icon-remove-sign"></i> Non',
					btnOkClass:"btn green",
					btnCancelClass:"btn btn-danger",
					placement:'bottom',
					onConfirm:(event,element)=>{
						event.preventDefault()//prevent scroll top
						const route = 'calendar/event/bookingmultiple/' + this.bookingMultiple.id
						let vm = this
						axios.delete(route).then(response => {
							if(response.data.deleted){
								this.$emit('close')
								this.$emit('refetch-events')
								this.$emit('snotify')
							}else{//error
								let errors = {booking_contains_groups:hasGroupError}
								if(response.data.hasOwnProperty('error') && errors.hasOwnProperty(response.data.error)){
									this.customErrorMessage = {error : true,message:"Erreur lors de la suppression :"}
									this.customErrors = [errors.booking_contains_groups]
								}else{
									vm.$snotify.error('Une erreur est survenue')
								}
							}
						}).catch(function(error){
							vm.$snotify.error(error.response.statusText,'Erreur '+error.response.status,{timeout:5000})
						})
					}
				};
				$(event.target).confirmation(confirmConfig);
				$(event.target).confirmation('show');
			}
		},
	}
}
</script>